import { createClient } from "@supabase/supabase-js"

import type { Database } from "@/types/database.types"

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY

if (!supabaseUrl || !supabasePublishableKey) {
  console.error("Missing Supabase environment variables. Check your .env file.")
}

export const supabase = createClient<Database>(supabaseUrl || "", supabasePublishableKey || "", {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})

export type { Session, User } from "@supabase/supabase-js"
